import { createFileRoute } from '@tanstack/react-router'

import { SecuritySettingsPage } from '@/features/settings/section-pages'

export const Route = createFileRoute('/_app/settings/security')({
  component: SecuritySettingsPage,
})
